import { combineReducers, Reducer } from 'redux';
import { History } from 'history';
import { IAppState, IAppAction } from './app.types';

import { connectRouter, LocationChangeAction } from 'connected-react-router';
import { apiReducer } from './api/api.reducer';
import { authReducer } from './auth/auth.reducer';
import { resourceReducer } from './resource/resource.reducer';
import { dialogReducer } from './dialog/dialog.reducer';
import { pageReducer } from './page/page.reducer';
import { taskModalsReducer } from './task-modals/task-modals.reducer';
import { filterReducer } from './page/boards/boards.reducers';

export const createAppReducer = (history: History): Reducer<IAppState, IAppAction | LocationChangeAction> =>
  combineReducers({
    api: apiReducer,
    auth: authReducer,
    dialog: dialogReducer,
    resource: resourceReducer,
    page: pageReducer,
    taskModals: taskModalsReducer,
    filter: filterReducer,
    router: connectRouter(history),
  });
